var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7116_13)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M256.1 86.3C308.7 86.3 355.3 104.1 398.1 133.5C420.2 148.7 440.5 166.4 458.8 186C478 206.7 495.7 228.7 510.8 252.6C512.4 255.1 512.4 256.9 510.8 259.4C497.2 280.4 482 300.4 465.3 319.1C439.9 347.6 411.2 372.1 378.3 391.5C349.5 408.5 318.5 420 285.2 424C235.9 429.8 189 421.2 145 397.8C100.5 374.3 63.7999 341.5 32.4999 302.6C21.3999 288.8 11.6999 273.9 1.1999 259.6C-0.700103 257 -0.200103 255 1.2999 252.4C14.2999 231.4 29.4999 212.2 45.8999 193.8C74.6999 161.6 107.3 134.3 145.7 114C170.9 100.6 198.3 91.8 226.6 88C236.4 86.8 246.3 86.8 256.1 86.3ZM380.5 256C379.9 185.6 324.1 131.5 255.8 131.6C187.4 131.3 131.7 186.4 131.4 254.8V256.2C131.5 325.4 186.6 380.7 256 380.6C325.2 380.5 380 325.4 380.5 256Z",
    fill: "url(#paint0_linear_7116_13)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256 333.8C213.2 333.8 178.2 298.8 178.2 256C178.2 213.2 213.3 178.3 256.1 178.3C298.9 178.3 333.7 213.5 333.6 256.3C333.6 298.8 298.5 333.8 256 333.8Z",
    fill: "url(#paint1_linear_7116_13)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7116_13",
    x1: 5.2299,
    y1: 5.49499,
    x2: 504.69,
    y2: 504.955,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1AA3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F56F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7116_13",
    x1: 5.29693,
    y1: 5.42801,
    x2: 504.757,
    y2: 504.888,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1AA3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F56F6"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7116_13"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShow);
export default __webpack_public_path__ + "static/media/show.306e9b3fef598a7a814b06c07f402f50.svg";
export { ForwardRef as ReactComponent };